export default __webpack_public_path__ + "static/media/lock.0ad64a97.png";